module.exports = __webpack_public_path__ + "img/img38.95a43db1.svg";